import { UserPageService } from './../user-page/user-page.service';
import { Component, OnChanges, SimpleChanges, Input, AfterViewInit } from '@angular/core';
import { UserRoleService } from 'src/app/services/user-role.service';
import { Employee } from 'src/app/data/models/employee.model';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'roles-permissions',
  templateUrl: './roles-permissions.component.html',
  styleUrls: ['./roles-permissions.component.scss']
})

export class RolesPermissionsComponent implements OnChanges, AfterViewInit {

  listCompany: any;
  listRole: any;
  editedUser;
  editedUserRole;
  employee = new Employee({});
  listRolesPermissions: any[];
  employeeId;
  companyId;
  companyName;
  roleName;
  @Input() employeeCompany;
  // @ViewChild('roleAssignForm', { static: false }) roleAssignForm: NgForm;
  roleAssignForm: FormGroup;
  formSubmitted = false;
  selectedApps: any[];
  appList: any[];
  isAppDefault: boolean;

  constructor(
    private userRoleService: UserRoleService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private userPageService: UserPageService,
    private fb: FormBuilder,

  ) {
    this.listRolesPermissions = [];
    this.listRole = [];
    this.roleAssignForm = this.fb.group({
      companyName: this.fb.control({ value: null, disabled: true }),
      appInfo: this.fb.group({
        isDefaultApps: this.fb.control([]),
        selectedAppIds: this.fb.control([]),
        selectedRolesPermission: this.fb.array([])
      })

    });

  }

  ngAfterViewInit() {
    this.userPageService.statusChangeSubScriptionSubjectStep.subscribe((stepNumber: number) => {
      if (stepNumber === 2) {
        this.userPageService.formChangesSubscription = this.roleAssignForm.statusChanges.subscribe(() => {
          this.userPageService.formIsDirtySubject.next({
            dirty: this.roleAssignForm.dirty,
            formNumber: 2
          });
        });
      }
    });
  }

  userRolePermission() {
    this.formSubmitted = true;
    if (this.roleAssignForm.invalid) {
      return false; // invalid form state  returning here
    }
    this.employee.companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    if (this.employee.companyId && this.employeeId) {
      const payload = [
        {
          companyId: this.employee.companyId,
          employeeId: this.employeeId,
          roleId: this.roleAssignForm.get('roleIds').value,
        }
      ];

      // this.userRoleService.assignRoleToUser(payload).subscribe((response) => {
      //   // const rolePermission = {
      //   //   companyName: this.companyName,
      //   //   companyId: this.employee.companyId,
      //   //   roleId: this.employee.roleIds,
      //   //   roleName: '',
      //   //   listPermissions: []
      //   // };

      //   this.editRolePermission();
      //   if (response.status === 200) {
      //     this.toastr.success('Role is assigned to the employee.');
      //   }
      //   this.roleAssignForm.reset(this.roleAssignForm.getRawValue());
      //   // this.stepper.next();
      //   // this.userRoleService.getAssignedPermissions(this.employee.roleIds).subscribe(data => {
      //   //   rolePermission.roleName = this.listRole.find(x => x.id === this.employee.roleIds).name;
      //   //   rolePermission.listPermissions = data;
      //   //   this.listRolesPermissions.push(rolePermission);
      //   // });

      // });
    } else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Please create employee');
      return false;
    }
  }

  // handleEdit(element) {
  //   sessionStorage.setItem('userrole', JSON.stringify(element));

  //   if (sessionStorage.getItem('userrole')) {
  //     this.editedUserRole = JSON.parse(sessionStorage.getItem('userrole'));
  //     this.employee.companyId = this.editedUserRole.companyId;
  //     this.employee.roleIds = this.editedUserRole.roleIds;
  //     this.employee.id = this.editedUserRole.id;
  //   }
  // }

  onChangeCompany(companyId) {
    this.userRoleService.getRoleByCompanyId(companyId).subscribe(data => {
      this.listRole = data;
    });
  }

  deleteRole(role) {
    const payload = [
      {
        companyId: null,
        id: null,
      }
    ];
    // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
    //   payload[0].companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    //   payload[0].id = this.employeeId;
    // }
    // else {
    //   payload[0].companyId = this.employee.companyId;
    //   payload[0].id = this.employeeId;
    // }
    payload[0].companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    payload[0].id = this.employeeId;

    const title = 'Confirm';
    const message = 'Do you wish to remove this item?';
    this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
      if (result) {
        this.userRoleService.deleteAssignedRole(payload[0].companyId, payload[0].id, role.roleId).subscribe(response => {
          this.toastr.success('Role removed for an employee.', 'Success');
          this.listRolesPermissions = this.listRolesPermissions.filter(x => x.roleId !== role.roleId);
        });
      }
    });
  }

  editRolePermission() {
    this.listRolesPermissions = [];
    const payload = [
      {
        companyId: null,
        id: null,
      }
    ];
    // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
    //   payload[0].companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    //   payload[0].id = this.employeeId;
    // }
    // else {
    //   payload[0].companyId = this.employee.companyId;
    //   payload[0].id = this.employeeId;
    // }

    payload[0].companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
    payload[0].id = this.employeeId;

    if (payload[0].companyId && payload[0].id) {
      this.userRoleService.getRoleToUser(payload[0].companyId, payload[0].id, payload).subscribe((response) => {
        response.forEach((role) => {
          this.userRoleService.getAssignedPermissionsForApp(role.roleId).subscribe((data: any) => {
            const rolePermission = {
              companyName: role.companyName ? role.companyName : '',
              companyId: role.companyId ? role.companyId : null,
              roleId: role.roleId ? role.roleId : null,
              roleName: role.roleName ? role.roleName : '',
              listPermissions: []
            };
            let listPermissions = [];
            if (data?.modulePermissions) {
              listPermissions = data?.modulePermissions[0].permissionList;
            }
            if (data?.permissionList) {
              listPermissions.push(...data.permissionList);
            }

            rolePermission.listPermissions = listPermissions;
            this.listRolesPermissions.push(rolePermission);
          });
        });
      });
    }
  }

  ngOnChanges(e: SimpleChanges) {
    if (e.employeeCompany && e.employeeCompany.currentValue) {
      this.companyName = e.employeeCompany.currentValue.companyName;
      this.employee.companyId = e.employeeCompany.currentValue.companyId;
      this.employeeId = e.employeeCompany.currentValue.employeeId;

      this.roleAssignForm.patchValue({
        companyName: this.companyName
      });

      // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
      //   this.userRoleService.getRoleByCompanyId(parseInt(sessionStorage.getItem('selectedCompanyId'))).subscribe(data => {
      //     this.listRole = data;
      //   });
      // } else {
      //   this.userRoleService.getRoleByCompanyId(this.employee.companyId).subscribe(data => {
      //     this.listRole = data;
      //   });
      // }
      this.userRoleService.getRoleByCompanyId(parseInt(sessionStorage.getItem('selectedCompanyId'))).subscribe(data => {
        this.listRole = data;
      });
      this.userRoleService.getAppListByCompanyId(parseInt(sessionStorage.getItem('selectedCompanyId'))).subscribe(data => {
        // console.log("applist", data);
        this.appList = data;
        this.getAppUserRoles();
      });
      if (sessionStorage.getItem('user')) {
        // this.listRolesPermissions=[];
        this.editRolePermission();

      }


    }
  }


  // dialogueInitializer(event, title: string, message: string) {
  dialogueInitializer(title: string, message: string) {
    // const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: ['Cancel', 'Delete']
      }
    });
    return dialogRef;
  }

  onSelectionChange(e) {
    //  console.log("e", e);
    let items = [];
    if (e.value?.length > 0) {
      items.push(...e.value);
    } else if (e.itemValue) {
      items.push(e.itemValue);
    }
    let addItems = [];
    let removeItems = [];
    const selectedRolesPermission: any[] = this.roleAssignForm.value?.appInfo?.selectedRolesPermission;
    if (selectedRolesPermission?.length > 0) {
      let selectedRolesPermissionAppIds: any[] = selectedRolesPermission.map(x => x.appId);
      let selectedItemsIds: any[] = items.map(x => x.application.id);
      addItems = items.filter(x => !selectedRolesPermissionAppIds.includes(x.application.id));
      removeItems = selectedRolesPermissionAppIds.filter(x => !selectedItemsIds.includes(x));
      if (removeItems.length > 0) {
        removeItems.forEach(x => {
          const initiateArray = this.roleAssignForm.get('appInfo.selectedRolesPermission') as FormArray;
          const removeItemIndex = (this.roleAssignForm.value.appInfo.selectedRolesPermission as any[]).findIndex(y => y.appId === x);
          initiateArray.removeAt(removeItemIndex);
          this.selectedApps = this.selectedApps.filter(y => y.appId != x);
        });
      }
    } else {
      addItems = [...items];
    }
    this.roleAssignForm.value?.appInfo?.selectedRolesPermission
    addItems.forEach((item) => {
      this.addDynamicControls(item)
    });
  }

  addDynamicControls(controlValue, mode?) {
    const appId = controlValue?.application?.id ? controlValue?.application?.id : 0;
    const selectedRoles = this.roleAssignForm.value?.appInfo?.selectedRolesPermission ? Object.values(this.roleAssignForm.value?.appInfo?.selectedRolesPermission) : [];
    const newGroup = this.fb.group({
      appId: this.fb.control(mode && mode === 'EDITAPP' ? controlValue.appId : appId),
      appName: this.fb.control(mode && mode === 'EDITAPP' ? controlValue.name : controlValue.application.name),
      roleId: this.fb.control(mode && mode === 'EDITAPP' ? controlValue.roleId : null),
      isAppDefault: this.fb.control(mode && mode === 'EDITAPP' ? controlValue.isAppDefault : selectedRoles.length === 0)
    });
    const initiateArray = this.roleAssignForm.get('appInfo.selectedRolesPermission') as FormArray;
    initiateArray.push(newGroup);
    if (!mode) {
      this.selectedApps = this.roleAssignForm.value?.appInfo?.selectedRolesPermission ? Object.values(this.roleAssignForm.value?.appInfo?.selectedRolesPermission) : [];
      this.selectedApps.forEach((x, index) => {
        if (x.roleId) {
          const roleList = (this.appList.find((item: any) => item.application.id === x.appId))?.roles;
          const role = roleList.find((y) => y.roleId === x.roleId);
          this.handleRoleChange(role, index)
        }
      })
    }

  }

  getAppName(index) {
    const val = this.roleAssignForm.get('appInfo').get('selectedRolesPermission').value[index];
    return (this.appList.find((item: any) => item.application.id === val.appId))?.application['name'];
  }
  getRoleList(index) {
    const val = this.roleAssignForm.get('appInfo').get('selectedRolesPermission').value[index];
    return (this.appList.find((item: any) => item.application.id === val.appId))?.roles
  }

  getSelectedRolesPermission() {
    return (this.roleAssignForm.get('appInfo').get('selectedRolesPermission') as FormArray)?.controls;
  }
  trackByIdFn(index: number, item: any) {
    return item.appId; // or unique identifier of your choice
  }

  onSave() {
    //  console.log("forms value", this.roleAssignForm.value);
    const selectedApps = [];
    this.selectedApps.map(x => {
      let app = {
        appId: x.appId,
        roleId: x.roleId,
        roleName: x.roleName,
        isAppDefault: x.isAppDefault
      }
      selectedApps.push(app);
    });
    const payload: any = {
      companyId: this.employee.companyId ? this.employee.companyId : null,
      userId: this.employeeId ? this.employeeId : null,
      selectedApps: selectedApps
    };
    this.userRoleService.saveAppRolesAndPermission(payload).subscribe((response) => {
      // console.log("response $$$$", response);
      if (response.status === 200 && response.message) {
        this.toastr.success(response.message, 'Success');
      }
    });

  }

  handleRoleChange(role, index) {
    this.userRoleService.getAssignedPermissionsForApp(role.roleId).subscribe((data: any) => {
      //console.log("data",data);
      if (data) {
        let listPermissions = [];
        if (data?.modulePermissions) {
          listPermissions = data?.modulePermissions[0].permissionList;
        }
        if (data?.permissionList) {
          listPermissions.push(...data.permissionList);
        }
        this.selectedApps[index].roleId = role.roleId;
        this.selectedApps[index].roleName = role.roleName ? role.roleName : '';
        this.selectedApps[index].listPermissions = listPermissions;

      }

    });
  }

  handleDefault(item) {
    this.selectedApps.map(x => x.isAppDefault = x.appId === item.appId ? true : false);
  }
  getAppUserRoles() {
    this.userRoleService.getAppUserRoles(parseInt(sessionStorage.getItem('selectedCompanyId')), this.employeeId).subscribe(data => {
      const appUserRolesData: any = data;
      const selectedAppIds = [];
      const itemsArray = this.roleAssignForm.get('appInfo.selectedRolesPermission') as FormArray;
      if (appUserRolesData) {
        appUserRolesData.selectedApps.forEach((element, index) => {
          const appEle = this.appList.find(ele => ele.application.id === element['appId']);
          this.selectedApps = appUserRolesData.selectedApps;
          this.userRoleService.getAssignedPermissionsForApp(element['roleId']).subscribe((data: any) => {
            let listPermissions = [];
            if (data?.modulePermissions) {
              listPermissions = data?.modulePermissions[0].permissionList;
            }
            if (data?.permissionList) {
              listPermissions.push(...data.permissionList);
            }
            this.selectedApps[index].listPermissions = listPermissions;
            this.selectedApps[index].appName = appEle.application.name;
            // this.listRolesPermissions.push(rolePermission);
          });
          element.name = appEle.application.name;
          selectedAppIds.push(appEle);
          this.addDynamicControls(element, 'EDITAPP');
        });
        this.roleAssignForm.get('appInfo').patchValue({
          selectedAppIds: selectedAppIds
        });
      }
    });
  }


}
